import { DeanteData } from "../../../Universal/API/Context-API/AppProvider";
import { UnitListEntry } from "./types";

export const normalizeText = (value: unknown) => {
  const text = String(value ?? "").trim();
  return text.length > 0 ? text : null;
};

export const getPrimaryImage = (unit: UnitListEntry) => {
  const medium = unit.unit.sliders?.medium?.[0];
  const full = unit.unit.sliders?.full?.[0];
  return medium || full || unit.url || unit.unit.uri_small || unit.unit.uri_full || "";
};

export const getGalleryCount = (unit: UnitListEntry) => {
  const mediumCount = unit.unit.sliders?.medium?.length ?? 0;
  const fullCount = unit.unit.sliders?.full?.length ?? 0;
  return Math.max(mediumCount, fullCount, getPrimaryImage(unit) ? 1 : 0);
};

export const getUnitCardFacts = (unit: DeanteData) =>
  [normalizeText(unit.poverh), normalizeText(unit.material)]
    .filter(Boolean)
    .slice(0, 2) as string[];

export const getCollectionLabel = (unit: DeanteData) => normalizeText(unit.col);

export const getPriceText = ({
  unit,
  isDiscount,
  compact = false,
}: {
  unit: UnitListEntry;
  isDiscount?: boolean;
  compact?: boolean;
}) => {
  const key = isDiscount ? "discounted_price" : "price";
  const rawValue = unit[key];

  if (rawValue && parseInt(rawValue + "") > 999997) {
    return "По запросу";
  }

  const text = String(rawValue ?? "").trim();

  if (!compact) {
    return text;
  }

  return text
    .replace(/\s*(р|руб\.?)\s*\/\s*шт\.?/gi, " ₽/шт")
    .replace(/\s*(р|руб\.?)\s*\/\s*м2?\.?/gi, " ₽/м")
    .replace(/\s*(р|руб\.?)\s*\/\s*компл\.?/gi, " ₽/компл")
    .replace(/\s+/g, " ")
    .trim();
};

export const getFallbackNumColumns = ({
  isSmallVersion,
  isMediumVersion,
}: {
  isSmallVersion: boolean;
  isMediumVersion: boolean;
}) => {
  if (isSmallVersion) return 2;
  if (isMediumVersion) return 3;
  return 4;
};

export const getResolvedNumColumns = ({
  layoutWidth,
  fallbackNumColumns,
}: {
  layoutWidth: number;
  fallbackNumColumns: number;
}) => {
  if (layoutWidth <= 0) return fallbackNumColumns;
  if (layoutWidth < 360) return 1;
  if (layoutWidth < 640) return 2;
  if (layoutWidth < 980) return 2;
  if (layoutWidth < 1480) return 3;
  return 4;
};

export const getEstimatedItemSize = ({
  isSmallVersion,
  isMediumVersion,
  scaleAll,
}: {
  isSmallVersion: boolean;
  isMediumVersion: boolean;
  scaleAll: number;
}) => {
  const baseHeight = isSmallVersion ? 340 : isMediumVersion ? 410 : 470;
  return baseHeight * scaleAll;
};

export const getUnitCardMediaMetrics = ({
  isSmallVersion,
  isMediumVersion,
  scaleAll,
}: {
  isSmallVersion: boolean;
  isMediumVersion: boolean;
  scaleAll: number;
}) => {
  const mediaHeight = isSmallVersion
    ? 112 * scaleAll
    : isMediumVersion
    ? 172 * scaleAll
    : 228 * scaleAll;
  const carouselWidth = isSmallVersion
    ? 168 * scaleAll
    : isMediumVersion
    ? 360 * scaleAll
    : 460 * scaleAll;

  return {
    mediaHeight,
    carouselWidth,
    imageMaxWidth: carouselWidth,
  };
};
